<form action="{{printUrl}}" method="post" #boardingPassForm>
  <input type="hidden" name="data" />
  <input type="hidden" name="culture" />
</form>